/* tslint:disable */
/* eslint-disable */
/**
 * AllOfUs Workbench API
 * The API for the AllOfUs workbench.  Throughout, we use integer/int64 in preference to string/date-time because Swagger\'s date formatting is inconsistent between server and client. Time values are stored as milliseconds since the UNIX epoch.  Note: all requests tagged as \"cron\" must have the header X-Appengine-Cron: true, which app engine itself only sets when invoking as a cronjob. See https://cloud.google.com/appengine/docs/standard/java/config/cron#securing_urls_for_cron and o.p.w.interceptors.CronInterceptor which implements the header check. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  CloudStorageTraffic,
  ErrorResponse,
  WorkspaceAdminView,
  WorkspaceAuditLogQueryResponse,
  WorkspaceRecoveryErrorLog,
  WorkspaceUserAdminView,
  WorkspaceWaitingForRetrievalListResponse,
} from '../models';
import {
    CloudStorageTrafficFromJSON,
    CloudStorageTrafficToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    WorkspaceAdminViewFromJSON,
    WorkspaceAdminViewToJSON,
    WorkspaceAuditLogQueryResponseFromJSON,
    WorkspaceAuditLogQueryResponseToJSON,
    WorkspaceRecoveryErrorLogFromJSON,
    WorkspaceRecoveryErrorLogToJSON,
    WorkspaceUserAdminViewFromJSON,
    WorkspaceUserAdminViewToJSON,
    WorkspaceWaitingForRetrievalListResponseFromJSON,
    WorkspaceWaitingForRetrievalListResponseToJSON,
} from '../models';

export interface WorkspaceAdminApiGetCloudStorageTrafficRequest {
    workspaceNamespace: string;
}

export interface WorkspaceAdminApiGetWorkspaceAdminViewRequest {
    workspaceNamespace: string;
}

export interface WorkspaceAdminApiGetWorkspaceAuditLogEntriesRequest {
    workspaceNamespace: string;
    limit?: number;
    after?: number;
    before?: number;
}

export interface WorkspaceAdminApiGetWorkspaceCollaboratorsRequest {
    namespace: string;
}

export interface WorkspaceAdminApiGetWorkspaceRecoveryErrorLogsRequest {
    namespace: string;
}

/**
 * 
 */
export class WorkspaceAdminApi extends runtime.BaseAPI {

    /**
     * Returns a time series of cloud storage traffic for the given project. Requires the RESEARCHER_DATA_VIEW authority.
     */
    async getCloudStorageTrafficRaw(requestParameters: WorkspaceAdminApiGetCloudStorageTrafficRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CloudStorageTraffic>> {
        if (requestParameters.workspaceNamespace === null || requestParameters.workspaceNamespace === undefined) {
            throw new runtime.RequiredError('workspaceNamespace','Required parameter requestParameters.workspaceNamespace was null or undefined when calling getCloudStorageTraffic.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aou_oauth", []);
        }

        const response = await this.request({
            path: `/v1/admin/workspaces/{workspaceNamespace}/cloudStorageTraffic`.replace(`{${"workspaceNamespace"}}`, encodeURIComponent(String(requestParameters.workspaceNamespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CloudStorageTrafficFromJSON(jsonValue));
    }

    /**
     * Returns a time series of cloud storage traffic for the given project. Requires the RESEARCHER_DATA_VIEW authority.
     */
    async getCloudStorageTraffic(workspaceNamespace: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CloudStorageTraffic> {
        const response = await this.getCloudStorageTrafficRaw({ workspaceNamespace: workspaceNamespace }, initOverrides);
        return await response.value();
    }

    /**
     * Given a workspace namespace (Google Cloud Platform  Project ID), returns workspace details. Requires the RESEARCHER_DATA_VIEW authority.
     */
    async getWorkspaceAdminViewRaw(requestParameters: WorkspaceAdminApiGetWorkspaceAdminViewRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkspaceAdminView>> {
        if (requestParameters.workspaceNamespace === null || requestParameters.workspaceNamespace === undefined) {
            throw new runtime.RequiredError('workspaceNamespace','Required parameter requestParameters.workspaceNamespace was null or undefined when calling getWorkspaceAdminView.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aou_oauth", []);
        }

        const response = await this.request({
            path: `/v1/admin/workspaces/{workspaceNamespace}`.replace(`{${"workspaceNamespace"}}`, encodeURIComponent(String(requestParameters.workspaceNamespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkspaceAdminViewFromJSON(jsonValue));
    }

    /**
     * Given a workspace namespace (Google Cloud Platform  Project ID), returns workspace details. Requires the RESEARCHER_DATA_VIEW authority.
     */
    async getWorkspaceAdminView(workspaceNamespace: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkspaceAdminView> {
        const response = await this.getWorkspaceAdminViewRaw({ workspaceNamespace: workspaceNamespace }, initOverrides);
        return await response.value();
    }

    /**
     * Fetch audit logs involving this workspace as either a subject or object. Requires the RESEARCHER_DATA_VIEW authority. 
     */
    async getWorkspaceAuditLogEntriesRaw(requestParameters: WorkspaceAdminApiGetWorkspaceAuditLogEntriesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkspaceAuditLogQueryResponse>> {
        if (requestParameters.workspaceNamespace === null || requestParameters.workspaceNamespace === undefined) {
            throw new runtime.RequiredError('workspaceNamespace','Required parameter requestParameters.workspaceNamespace was null or undefined when calling getWorkspaceAuditLogEntries.');
        }

        const queryParameters: any = {};

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.after !== undefined) {
            queryParameters['after'] = requestParameters.after;
        }

        if (requestParameters.before !== undefined) {
            queryParameters['before'] = requestParameters.before;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aou_oauth", []);
        }

        const response = await this.request({
            path: `/v1/admin/workspaces/{workspaceNamespace}/audit`.replace(`{${"workspaceNamespace"}}`, encodeURIComponent(String(requestParameters.workspaceNamespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkspaceAuditLogQueryResponseFromJSON(jsonValue));
    }

    /**
     * Fetch audit logs involving this workspace as either a subject or object. Requires the RESEARCHER_DATA_VIEW authority. 
     */
    async getWorkspaceAuditLogEntries(workspaceNamespace: string, limit?: number, after?: number, before?: number, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkspaceAuditLogQueryResponse> {
        const response = await this.getWorkspaceAuditLogEntriesRaw({ workspaceNamespace: workspaceNamespace, limit: limit, after: after, before: before }, initOverrides);
        return await response.value();
    }

    /**
     * List of collaborators for a workspace. RESEARCHER_DATA_VIEW authority required.
     */
    async getWorkspaceCollaboratorsRaw(requestParameters: WorkspaceAdminApiGetWorkspaceCollaboratorsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WorkspaceUserAdminView>>> {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace','Required parameter requestParameters.namespace was null or undefined when calling getWorkspaceCollaborators.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aou_oauth", []);
        }

        const response = await this.request({
            path: `/v1/admin/workspaces/{namespace}/collaborators`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WorkspaceUserAdminViewFromJSON));
    }

    /**
     * List of collaborators for a workspace. RESEARCHER_DATA_VIEW authority required.
     */
    async getWorkspaceCollaborators(namespace: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WorkspaceUserAdminView>> {
        const response = await this.getWorkspaceCollaboratorsRaw({ namespace: namespace }, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all recovery error logs for a workspace
     */
    async getWorkspaceRecoveryErrorLogsRaw(requestParameters: WorkspaceAdminApiGetWorkspaceRecoveryErrorLogsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<WorkspaceRecoveryErrorLog>>> {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace','Required parameter requestParameters.namespace was null or undefined when calling getWorkspaceRecoveryErrorLogs.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aou_oauth", []);
        }

        const response = await this.request({
            path: `/v1/admin/workspaces/{namespace}/recoveryErrorLogs`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(WorkspaceRecoveryErrorLogFromJSON));
    }

    /**
     * Retrieves all recovery error logs for a workspace
     */
    async getWorkspaceRecoveryErrorLogs(namespace: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<WorkspaceRecoveryErrorLog>> {
        const response = await this.getWorkspaceRecoveryErrorLogsRaw({ namespace: namespace }, initOverrides);
        return await response.value();
    }

    /**
     * Returns all workspaces with recovery state REQUESTED.
     */
    async getWorkspacesWaitingForRetrievalRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<WorkspaceWaitingForRetrievalListResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("aou_oauth", []);
        }

        const response = await this.request({
            path: `/v1/admin/workspaces/waitingForRetrieval`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => WorkspaceWaitingForRetrievalListResponseFromJSON(jsonValue));
    }

    /**
     * Returns all workspaces with recovery state REQUESTED.
     */
    async getWorkspacesWaitingForRetrieval(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<WorkspaceWaitingForRetrievalListResponse> {
        const response = await this.getWorkspacesWaitingForRetrievalRaw(initOverrides);
        return await response.value();
    }

}
